import { ScheduleRequestListItem, usePreferenceBasedRequestsAccess } from '@frontend/schedule-helpers';
import { isEmpty } from '@frontend/validation';
import { useModalControl } from '@frontend/design-system';
import type { ScheduleRequestActionCalledFrom } from '../../hooks/use-schedule-request-actions';
import { PreferenceBasedScheduleRequestDetails } from './preference-based-request-item-details';
import { ScheduleRequestItemDetails } from './request-item-details';

interface ScheduleRequestDetailsProps {
  listItem: ScheduleRequestListItem;
  scheduleRequestId: string;
  requestVersion: string;
  locationId: string;
  isPaymentsEnabled: boolean;
  patientContactedAt?: string;
  dismissRequestModalProps: ReturnType<typeof useModalControl>;
  onDismissRequestIntent: (actionCalledFrom?: ScheduleRequestActionCalledFrom) => void;
  onMessage: (updateStatus: boolean, actionCalledFrom?: ScheduleRequestActionCalledFrom) => void;
  onPhoneCall: (actionCalledFrom?: ScheduleRequestActionCalledFrom) => void;
  onCompleteRequest: (actionCalledFrom?: ScheduleRequestActionCalledFrom) => void;
  onReviewCallLog: () => void;
  onViewConversation: () => void;
}

export const ScheduleRequestDetails = ({
  listItem,
  scheduleRequestId,
  requestVersion,
  locationId,
  isPaymentsEnabled,
  patientContactedAt,
  dismissRequestModalProps,
  onDismissRequestIntent,
  onCompleteRequest,
  onPhoneCall,
  onMessage,
  onReviewCallLog,
  onViewConversation,
}: ScheduleRequestDetailsProps) => {
  const { hasPreferenceBasedRequestsAccess } = usePreferenceBasedRequestsAccess();
  const isPreferenceBasedRequest = !isEmpty(listItem.aiRequestDetails);

  if (hasPreferenceBasedRequestsAccess && isPreferenceBasedRequest) {
    return (
      <PreferenceBasedScheduleRequestDetails
        listItem={listItem}
        patientContactedAt={patientContactedAt}
        dismissRequestModalProps={dismissRequestModalProps}
        onDismissRequestIntent={onDismissRequestIntent}
        onCompleteRequest={onCompleteRequest}
        onPhoneCall={onPhoneCall}
        onMessage={onMessage}
        onReviewCallLog={onReviewCallLog}
        onViewConversation={onViewConversation}
      />
    );
  }

  return (
    <ScheduleRequestItemDetails
      scheduleRequestId={scheduleRequestId}
      requestVersion={requestVersion}
      locationId={locationId}
      isPaymentsEnabled={isPaymentsEnabled}
    />
  );
};
